import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import * as yup from 'yup';
import _ from 'lodash';

import SelectControl from './SelectControl';
import RadioGroupControl from './RadioGroupControl';

function SingleChoiceWidget(props) {
    const intl = useIntl();

    const displayAsRadioGroup = props.widget.expanded;
    const Input = displayAsRadioGroup ? RadioGroupControl : SelectControl;
    const options = [...(_.get(props, 'widget.choices' || {})[intl.locale] || [])];

    // Wenn die Darstellung als <select> erfolgt, wollen wir eine Option anbieten, die die leere Auswahl darstellt.
    if (!displayAsRadioGroup) {
        options.unshift({
            value: '',
            label: intl.formatMessage({id: 'submission.form.select.emptyOption'})
        });
    }

    return <Input {...props} options={options}/>;
}

SingleChoiceWidget.propTypes = {
    widget: PropTypes.object,
    intl: PropTypes.object
};


export function type() {
    return 'choice_single';
}

export function initialValue(widget) {
    return '';
}

/**
 * @param widget
 * @param allowPartialSubmissions
 * @returns {StringSchema<string | undefined | null, object>}
 */
export function schema(widget, allowPartialSubmissions) {
    let schema = yup.string().nullable();

    if (!allowPartialSubmissions && widget.required) {
        schema = schema.required();
    }

    return schema;
}

export function component() {
    return SingleChoiceWidget;
}
